import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const WizardConstructionManagement = (props) => {
  let currentView = null;

  useEffect(() => {
   getData();
  }, []);

  async function getData() {
    // await props.initPage({epiData: props.iContent});
  }

//   switch (props.page) {
    // case 'invoicesPage': currentView = <InvoicePage context={props.context} iContent={props.iContent} />; break;
    // case 'questionsAndAnswersPage': currentView = <QuestionsAndAnswersPage context={props.context} iContent={props.iContent} />; break;
    // case 'callsDetailsPage' :  currentView = <CallsDetailsPage context={props.context} iContent={props.iContent} />; break;
//   }

  return (
    <div className='wizard-construction-management'>
      {currentView}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardConstructionManagement);
